export default function campaignAnalytics() {
    return {
        campaign: null,
        dailyInsights: [],
        campaignId: null,
        leads: [],
        views: [],
        filteredLeads: [],
        filteredViews: [],
        dateLabels: [],
        chart: null,
        zonesAnalytics: {},
        zonesInsights: [],
        creativesAnalytics: {},
        creativesInsights: [],
        filters: {
            date: {
                from: '',
                to: '',
            }
        },
        tab: 'total',
        init(campaignId) {
            this.campaignId = campaignId;
            this.loadLeads();
        },
        loadLeads() {
            axios.get(`/api/campaign/${this.campaignId}/data`).then(response => {
                this.campaign = response.data.campaign;
                this.leads = response.data.leads.map(lead => {
                    let date = new Date(lead.created_at);

                    return {
                        ...lead,
                        created_at: lead.created_at = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                    };
                });
                this.views = response.data.views.map(view => {
                    let date = new Date(view.created_at);

                    return {
                        ...view,
                        created_at: view.created_at = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                    };
                });
                this.dateFilter(this.views[0]['created_at']);
                this.applyFilters('leads', this.leads, (leads) => {
                    this.filteredLeads = leads;
                    this.applyFilters('views', this.views, (views) => {
                        this.filteredViews = views;
                        this.drawChart();

                        setTimeout(() => {
                            this.calcInsights();
                        }, 2500)
                    });
                });
            });
        },
        groupByDate(data) {
            return _.groupBy(data, "created_at");
        },
        dateFilter(from) {
            let date = new Date();
            const to = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            this.filters.date = { from, to };

            $('#date-filter').daterangepicker({
                startDate: from,
                endDate: to,
                locale: {
                    format: 'Y-M-DD'
                }
            }, (start, end) => {
                this.setFilter('date', {
                    from: start.format('Y-M-D'),
                    to: end.format('Y-M-D'),
                });
                this.applyFilters('leads', this.leads, (leads) => {
                    this.filteredLeads = leads;
                    this.applyFilters('views', this.views, (views) => {
                        this.filteredViews = views;
                        this.drawChart();
                        this.calcInsights();
                    });
                });
            });
        },
        countfyObject(object) {
            for (var key of Object.keys(object)) {
                object[key] = object[key].length;
            }
            return object;
        },
        setFilter(name, data) {
            this.filters[name] = data;
        },
        applyFilters(type, data, callback) {
            data = this.applyDateFilter(data);
            this.calcZones(type, data);
            this.calcCreatives(type, data);
            data = this.groupByDate(data);
            data = this.countfyObject(data);
            callback(data);
        },
        applyDateFilter(data) {
            return data.filter(item => {
                return moment(item.created_at).isBetween(this.filters.date.from, this.filters.date.to, null, '()') ||
                    moment(item.created_at, "DD-MM-YYYY").isSame(moment(this.filters.date.from, "DD-MM-YYYY")) ||
                    moment(item.created_at, "DD-MM-YYYY").isSame(moment(this.filters.date.to, "DD-MM-YYYY"));
            });
        },
        calcInsights() {
            const cpc = this.campaign.cpc;
            const days = this.generateChartLabels();
            let dailyInsights = [];
            let filteredLeads = this.filteredLeads;
            let filteredViews = this.filteredViews;
            for (var i = 0; i < days.length; i++) {
                const day = days[i];
                const leads = filteredLeads[day] || 0;
                const views = filteredViews[day] || 0;
                dailyInsights.push({
                    'index': i + 1,
                    'day': day,
                    'conversions': leads,
                    'clicks': views,
                    'conversion_rate': views == 0 ? 0 : (leads / views * 100).toFixed(2),
                    'cost': (views * cpc).toFixed(2),
                    'coc': (views === 0 || leads === 0) ? 0 : (views * cpc / leads).toFixed(2),
                })
            }
            this.dailyInsights = [...dailyInsights, this.dailyInsightsTotals(dailyInsights)];
        },
        calcZones(type, data) {
            let zones = JSON.parse(JSON.stringify(this.zonesAnalytics));
            for (var i = 0; i < data.length; i++) {
                let zone_id = data[i].zone_id || 'no zone';
                if (!zones[zone_id]) {
                    zones[zone_id] = {leads: 0, views: 0};
                    zones[zone_id][type] = 0;
                } else {
                    zones[zone_id][type] += 1;
                }
            }

            if (type === 'views') {
                let insights = [];
                const cpc = this.campaign.cpc;
                let keys = Object.keys(zones);
                for (var i = 0; i < keys.length; i++) {

                    let clicks = zones[keys[i]].views;
                    let conversions = zones[keys[i]].leads;
                    insights.push({
                        'index': i + 1,
                        'name': keys[i],
                        'clicks': clicks,
                        'conversions': conversions,
                        'conversion_rate': clicks == 0 ? 0 : (conversions / clicks * 100).toFixed(2),
                        'cost': (clicks * cpc).toFixed(2),
                        'coc': (clicks === 0 || conversions === 0) ? 0 : (clicks * cpc / conversions).toFixed(2),
                    })
                }
                this.zonesInsights = insights;
                console.log(insights)
            }
            this.zonesAnalytics = zones;
        },
        calcCreatives(type, data) {
            let creatives = JSON.parse(JSON.stringify(this.creativesAnalytics));
            for (var i = 0; i < data.length; i++) {
                let creative = data[i].cr || 'no creative';

                if (!creatives[creative]) {
                    creatives[creative] = {leads: 0, views: 0};
                    creatives[creative][type] = 0;
                } else {
                    creatives[creative][type] += 1;
                }
            }

            if (type === 'views') {
                let insights = [];
                const cpc = this.campaign.cpc;
                let keys = Object.keys(creatives);
                for (var i = 0; i < keys.length; i++) {

                    let clicks = creatives[keys[i]].views;
                    let conversions = creatives[keys[i]].leads;
                    insights.push({
                        'index': i + 1,
                        'name': keys[i],
                        'clicks': clicks,
                        'conversions': conversions,
                        'conversion_rate': clicks == 0 ? 0 : (conversions / clicks * 100).toFixed(2),
                        'cost': (clicks * cpc).toFixed(2),
                        'coc': (clicks === 0 || conversions === 0) ? 0 : (clicks * cpc / conversions).toFixed(2),
                    })
                }
                this.creativesInsights = insights;
                console.log(insights)
            }
            console.log(creatives)
            this.creativesAnalytics = creatives;
        },
        dailyInsightsTotals(insights) {
            const cpc = this.campaign.cpc;
            let totals = {
                'index': 'Totals',
                'day': `${insights[0].day} - ${insights[insights.length - 1].day}`,
                'conversions': 0,
                'clicks': 0,
            }
            for (var i = 0; i < insights.length; i++) {
                totals.conversions += insights[i].conversions;
                totals.clicks += insights[i].clicks;
            }

            totals = {
                ...totals,
                'conversion_rate': (totals.conversions / (totals.clicks || 1) * 100).toFixed(2),
                'cost': (totals.clicks * cpc).toFixed(2),
                'coc': (totals.clicks === 0 || totals.conversions === 0) ? 0 : (totals.clicks * cpc / totals.conversions).toFixed(2),
            }

            return totals;
        },
        generateChartLabels() {
            const from = this.filters.date.from;
            const to = this.filters.date.to;

            return getDatesBetween((new Date(from)), (new Date(to))).map(date => {
                return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            });
        },
        labelize(data, labels) {
            let withLabel = {};
            for (var i = 0; i <= labels.length; i++) {
                withLabel[labels[i]] = data[labels[i]] ? data[labels[i]] : 0;
            }
            return withLabel;
        },
        drawChart() {
            var ctx = document.getElementById('campaign-chart').getContext('2d');

            const labels = this.generateChartLabels();
            if (window.chart) {window.chart.destroy();}
            window.chart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: '# of leads',
                        data: Object.values(this.labelize(this.filteredLeads, labels)),
                        backgroundColor: ['rgba(0, 0, 0, 0)'],
                        borderColor: ['rgba(114, 124, 245, 1)'],
                        borderWidth: 2
                    }, {
                        label: '# of views',
                        data: Object.values(this.labelize(this.filteredViews, labels)),
                        backgroundColor: ['rgba(0, 0, 0, 0)'],
                        borderColor: ['#f57281'],
                        borderWidth: 2
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
        }
    }
}

function getDatesBetween(startDate, endDate) {
    var dates = [],
    currentDate = startDate;
    endDate = new Date(endDate);
    endDate.setDate(endDate.getDate() + 1);

    addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    };
    while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
    }

    return dates;
};

function objectLastItem(object) {
    return object[Object.keys(object)[Object.keys(object).length - 1]];
}

function objectFirstItem(object) {
    return object[Object.keys(object)[0]];
}
